import React from 'react';
import Logo from '../GCLOGO.png';
// import { SignedIn, SignedOut } from '@clerk/clerk-react';
import { Popover, PopoverButton, PopoverPanel, Transition } from '@headlessui/react';
import { status } from '../hooks/AuthProvider';
import DownloadsNavLink from './DownloadsNavLink';
import HeaderCTA from './HeaderCTA';

type props = {};
type state = {
    loading: boolean;
    showingSolutions: boolean;
    isScrolled: boolean;
    isAuthenticated: boolean;
    isProductsOpen: boolean;
}

export default class LandingComponentProd extends React.Component<props, state> {
    constructor(props: any) {
        super(props);
        this.state = {
            loading: false,
            showingSolutions: false,
            isScrolled: false,
            isAuthenticated: false,
            isProductsOpen: false
        }
    }

    async componentDidMount() {
        const handleScroll = () => {
            this.setState({isScrolled: window.scrollY > 10});
        }
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }

    setShowing(showing: boolean) {
        this.setState({showingSolutions: showing});
    }

    render() {
        return <div className="min-h-screen bg-black text-white">
            <header
                className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
                    this.state.isScrolled ? "bg-black/80 backdrop-blur-sm" : "bg-transparent"
                }`}
            >
                <div className="container mx-auto px-4">
                    <div className="flex h-16 items-center justify-between">
                        <a href="/" className="flex items-center space-x-2 transition-opacity hover:opacity-80">
                            <img src={Logo} width={'200'} />
                            {/* <svg className="h-8 w-8 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                            />
                            </svg>
                            <span className="text-xl font-bold">GuardedContent</span> */}
                        </a>

                        {/* New middle section with dropdowns */}
                        <nav className="hidden md:flex items-center space-x-6">
                            <div className="relative">
                                <Popover
                                    onMouseEnter={() => this.setShowing(true)}
                                    onMouseLeave={() => this.setShowing(false)}
                                >
                                    <PopoverButton className="text-white hover:text-red-500 transition-colors flex items-center">Solutions</PopoverButton>
                                    <Transition
                                        enter="transition ease-out duration-200"
                                        enterFrom="opacity-0 translate-y-1"
                                        enterTo="opacity-100 translate-y-0"
                                        leave="transition ease-in duration-150"
                                        leaveFrom="opacity-100 translate-y-0"
                                        leaveTo="opacity-0 translate-y-1"
                                        show={this.state.showingSolutions}
                                    >
                                        <PopoverPanel
                                        anchor="bottom"
                                        className={`divide-y divide-white/5 rounded-xl bg-black/80 backdrop-blur-sm text-sm/6 [--anchor-gap:var(--spacing-5)] mt-2`}
                                        >
                                        <div className="p-3">
                                            <a className="block rounded-lg py-2 px-3 transition hover:bg-white/5" href="./#features">
                                                <p className="font-semibold text-white">General Media</p>
                                                <p className="text-white/50">Protect your content using DRM</p>
                                            </a>
                                            {/* <a className="block rounded-lg py-2 px-3 transition hover:bg-white/5" href="#">
                                                <p className="font-semibold text-white">Music</p>
                                                <p className="text-white/50">Protect your music using DRM</p>
                                            </a>
                                            <a className="block rounded-lg py-2 px-3 transition hover:bg-white/5" href="#">
                                                <p className="font-semibold text-white">Corporate Documents</p>
                                                <p className="text-white/50">Protect your documents using DRM</p>
                                            </a> */}
                                        </div>
                                        {/* <div className="p-3">
                                            <a className="block rounded-lg py-2 px-3 transition hover:bg-white/5" href="#">
                                            <p className="font-semibold text-white">Documentation</p>
                                            <p className="text-white/50">Start integrating products and tools</p>
                                            </a>
                                        </div> */}
                                        </PopoverPanel>
                                    </Transition>
                                </Popover>
                                {/* <button
                                    // onClick={() => this.setIsProductsOpen(!this.state.isProductsOpen)}
                                    onClick={() => this.setState({ isProductsOpen: !this.state.isProductsOpen })}
                                    className="text-white hover:text-red-500 transition-colors flex items-center"
                                >
                                    Products
                                    <svg className="ml-1 h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                                    </svg>
                                </button> */}
                            {/* {this.state.isProductsOpen && (
                                <div className="absolute top-full left-0 mt-2 w-56 bg-gray-900 border border-gray-800 rounded-md shadow-lg">
                                    <a href="#" className="block px-4 py-2 text-white hover:bg-white/10">Content Creation Suite</a>
                                    <a href="#" className="block px-4 py-2 text-white hover:bg-white/10">Analytics Dashboard</a>
                                    <a href="#" className="block px-4 py-2 text-white hover:bg-white/10">Collaboration Tools</a>
                                </div>
                            )} */}
                            </div>
                            {/* <a href="/pricing" className="text-white hover:text-red-500 transition-colors">Pricing</a> */}
                            <DownloadsNavLink />
                        </nav>

                        <nav className="flex items-center gap-4">
                            <HeaderCTA />
                        </nav>
                    </div>
                </div>
            </header>

            <header className="relative overflow-hidden pt-16">
                <div className="absolute inset-0 bg-gradient-to-r from-red-500/10 to-purple-500/10 animate-gradient" />
                    <div className="container mx-auto px-4 py-24 relative">
                        <div className="inline-block mb-4 px-4 py-2 bg-red-500/10 text-red-500 rounded-full hover:bg-red-500/20 transition-colors">
                            Welcome to GuardedContent
                        </div>
                        <h1 className="text-5xl md:text-7xl font-bold mb-6 bg-gradient-to-r from-white to-gray-400 bg-clip-text text-transparent">
                            Create Without Limits
                        </h1>
                        <p className="text-xl md:text-2xl text-gray-400 max-w-2xl mb-8">
                            The next generation platform for content creators. Secure, powerful, and built for your success.
                        </p>
                        <div className="flex flex-col sm:flex-row gap-4">
                            <button className="px-6 py-3 bg-red-600 hover:bg-red-500 text-white rounded-md transition-colors inline-flex items-center">
                            Start Creating
                            <svg className="ml-2 h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                            </svg>
                        </button>
                        <a href="#features" className="px-6 py-3 border border-red-500 text-red-500 hover:bg-red-500/10 rounded-md transition-colors">
                            Explore Features
                        </a>
                    </div>
                </div>
            </header>

            <section id="features" className="py-24 bg-gradient-to-b from-black to-gray-900">
                <div className="container mx-auto px-4">
                    <h2 className="text-3xl md:text-5xl font-bold text-center mb-16">
                        Everything You Need to Create
                        <span className="text-red-600"> Amazing Content</span>
                    </h2>
                    <div className="grid md:grid-cols-2 lg:grid-cols-2 gap-8">
                        {[
                        // {
                        //     icon: "M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z",
                        //     title: "Video Creation",
                        //     description: "Professional-grade video tools at your fingertips",
                        // },
                        // {
                        //     icon: "M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z",
                        //     title: "Image Studio",
                        //     description: "Edit and enhance your visual content",
                        // },
                        // {
                        //     icon: "M9 19V6l12-3v13M9 19c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zm12-3c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zM9 10l12-3",
                        //     title: "Audio Suite",
                        //     description: "Create and mix stunning audio content",
                        // },
                        {
                            svg: 'fa-regular fa-lock',
                            icon: "M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z",
                            title: "Content Protection",
                            description: "Keep your content secure using industry standard DRM (Digital Rights Management)",
                        },
                        // {
                        //     svg: 'fa-solid fa-video',
                        //     icon: "",
                        //     title: "Livestreaming",
                        //     description: "Stream with SRT for reduced latency"
                        // },
                        {
                            svg: 'fa-solid fa-play',
                            // icon: "M73 39c-14.8-9.1-33.4-9.4-48.5-.9S0 62.6 0 80L0 432c0 17.4 9.4 33.4 24.5 41.9s33.7 8.1 48.5-.9L361 297c14.3-8.7 23-24.2 23-41s-8.7-32.2-23-41L73 39z",
                            icon: '',
                            title: "Digital Media",
                            description: "Upload up to 4K quality videos and images"
                        }
                        // {
                        //     icon: "M13 10V3L4 14h7v7l9-11h-7z",
                        //     title: "AI Enhancement",
                        //     description: "Leverage AI to improve your content",
                        // },
                        ].map((feature, index) => (
                        <div
                            key={index}
                            className="p-6 bg-gray-900/50 border border-gray-800 rounded-lg hover:border-red-500/50 transition-colors"
                        >
                            <div className="mb-4">
                                {feature.svg ? (
                                    <i className={feature.svg + " text-red-500"} />
                                ) : (
                                    <svg className="h-8 w-8 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={feature.icon} />
                                </svg>
                                )}
                                {/* <svg className="h-8 w-8 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={feature.icon} />
                                </svg> */}
                            </div>
                            <h3 className="text-xl font-bold mb-2 text-white">{feature.title}</h3>
                            <p className="text-gray-400">{feature.description}</p>
                        </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Stats Section */}
            <section className="py-24 bg-gradient-to-b from-gray-900 to-black">
                <div className="container mx-auto px-4">
                    <div className="grid md:grid-cols-1 gap-8 text-center">
                        {[
                            // { number: "1M+", label: "Creators" },
                            // { number: "100M+", label: "Monthly Views" },
                            { number: "99.9%", label: "Uptime" },
                        ].map((stat, index) => (
                        <div key={index} className="p-8">
                            <div className="text-4xl md:text-6xl font-bold text-red-500 mb-2">{stat.number}</div>
                            <div className="text-gray-400 text-lg">{stat.label}</div>
                        </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* CTA Section */}
            <section className="py-24 relative overflow-hidden">
                <div className="absolute inset-0 bg-gradient-to-r from-red-500/10 to-purple-500/10 animate-gradient" />
                    <div className="container mx-auto px-4 relative">
                    <div className="max-w-3xl mx-auto text-center">
                        <h2 className="text-3xl md:text-5xl font-bold mb-6">Ready to Start Creating?</h2>
                        {/* <p className="text-xl text-gray-400 mb-8">Join thousands of creators who are already building their future with GuardedContent.</p> */}
                        <p className="text-xl text-gray-400 mb-8">Join thousands of creators who are already building their future with GuardedContent.</p>
                        <div className="flex flex-col sm:flex-row gap-4 justify-center">
                            <button className="px-6 py-3 bg-red-600 hover:bg-red-500 text-white rounded-md transition-colors">Get Started Now</button>
                            <button className="px-6 py-3 border border-red-500 text-red-500 hover:bg-red-500/10 rounded-md transition-colors">Watch Demo</button>
                        </div>
                    </div>
                </div>
            </section>

            {/* Footer */}
            <footer className="border-t border-gray-800 py-12">
                <div className="container mx-auto px-4">
                    <div className="grid md:grid-cols-4 gap-8">
                        <div>
                            <h3 className="font-bold text-xl mb-4">GuardedContent</h3>
                            <p className="text-gray-400">The future of content creation.</p>
                            <div className="mt-2 -ml-1 text-slate-400">
                                <iframe src="https://status.guardedcontent.com/badge?theme=dark" width="250" height="30" frameBorder="0" scrolling="no" style={{color: '#94a3b8'}}></iframe>
                            </div>
                        </div>
                        {[
                            {
                                title: "Product",
                                // links: ["Features", "Pricing", "Security", "Roadmap"],
                                links: [{
                                    name: 'Features',
                                    link: '#'
                                }, {
                                    name: 'Pricing',
                                    link: '#'
                                }, {
                                    name: 'Security',
                                    link: '#'
                                }, { 
                                    name: 'Roadmap',
                                    link: '#'
                                }]
                            },
                            {
                                title: "Resources",
                                // links: ["Blog", "Documentation", "Guides", "Help Center"],
                                links: [{
                                    name: 'Blog',
                                    link: '#'
                                }, {
                                    name: 'Documentation',
                                    link: '#'
                                }, {
                                    name: 'Guides',
                                    link: '#'
                                }, { 
                                    name: 'Help Center',
                                    link: '#'
                                }]
                            },
                            {
                                title: "Company",
                                // links: ["About", "Careers", "Contact", "Press"],
                                links: [{
                                    name: 'About',
                                    link: '#'
                                }, {
                                    name: 'Careers',
                                    link: '#'
                                }, {
                                    name: 'Contact',
                                    link: '#'
                                }, { 
                                    name: 'Press',
                                    link: '#'
                                }]
                            },
                            ].map((column, index) => (
                            <div key={index}>
                                <h3 className="font-bold mb-4">{column.title}</h3>
                                <ul className="space-y-2">
                                {column.links.map((link, linkIndex) => (
                                    <li key={linkIndex}>
                                        <a href="#" className="text-gray-400 hover:text-white transition-colors">
                                            {link.name}
                                        </a>
                                    </li>
                                ))}
                                </ul>
                            </div>
                        ))}
                        </div>
                    <div className="border-t border-gray-800 mt-12 pt-8 text-center text-gray-400">
                        <p>&copy; {new Date().getFullYear()} GuardedContent. All rights reserved.</p>
                    </div>
                </div>
            </footer>
        </div>
    }
}